
























import Component from 'vue-class-component';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ticketsDashboard } from '@/modules/shared/shared/store/namespaces';
import { TicketStatus } from '@/modules/shared/shared/domain/constants/constants';

@Component({
    components: {
        apexchart: VueApexCharts,
    },
})
export default class TicketsMonthSummary extends Vue {
    @ticketsDashboard.State('tickets') tickets;

    get isLoading(): boolean {
        return !this.tickets;
    }

    get chartType(): string {
        return 'pie';
    }

    get currentSeries(): number[] {
        let series: number[] = [];

        if (!this.isLoading && this.tickets.values) {
            series = [
                this.tickets.values.ticketsByStatus[0].total,
                this.tickets.values.ticketsByStatus[2].total,
                this.tickets.values.ticketsByStatus[1].total,
            ];
        }

        return series;
    }

    get summaryChartOptions(): object {
        let config: object = {};

        if (!this.isLoading && this.tickets.values) {
            const fontFamily: string = 'Roboto, sans-serif';

            config = {
                chart: {
                    type: this.chartType,
                    fontFamily,
                    dropShadow: {
                        enabled: true,
                        blur: 8,
                        opacity: 0.2,
                    },
                },
                labels: [
                    this.tickets.values.ticketsByStatus[0].status,
                    this.tickets.values.ticketsByStatus[2].status,
                    this.tickets.values.ticketsByStatus[1].status,
                ],
                dataLabels: {
                    formatter: function(val, opts) {
                        return val.toFixed(2).replace('.', ',') + '%';
                    },
                    style: {
                        fontFamily,
                        fontSize: '0.85rem',
                        fontWeight: 500,
                        colors: ['#fff', '#fff', '#fff'],
                    },
                },
                colors: ['#e91e63', '#ffc107', '#00bcd4'],
                tooltip: {
                    fillSeriesColor: false,
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                    },
                },
                legend: {
                    fontFamily,
                    position: 'bottom',
                    offsetY: 6,
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        opacityFrom: 0.7,
                        opacityTo: 1,
                        gradientToColors: ['#e91e63', '#ffc107', '#00bcd4'],
                        stops: [0, 100],
                    },
                },
                stroke: {
                    colors: ['#e91e63', '#ffc107', '#00bcd4'],
                    width: 1,
                },
                states: {
                    active: {
                        filter: {
                            type: 'none',
                        },
                    },
                },
            };
        }

        return config;
    }
}
